const MOUSE_POSITION = "mousePosition"
const TOUCH_POSITION = "touchPosition"
const WINDOW_SIZE = "windowSize"
const CONTAINER_SIZE = "containerSize"
const MOUSE_DIFF = "mouseDiff"
const MODAL = "modal"
const CAPABILITIES_INDEX = "capabilitiesIndex"
const MOBILE = "mobile"
const ENERGY_MODAL = "energyModal"

const INITIAL_PAGE_LOAD = "initialPageLoad"
const SHOW_INFO_POPUP = "showInfoPopup"
const INFO_POPUP_DATA = "infoPopupData"
const SHOW_ANNOUNCEMENT_BAR = "showAnnouncementBar"
const ANNOUNCEMENT_BAR_DATA = "announcementBarData"
const MAIN_DRAWER = "mainDrawer"
const SHOW_SITE_CREDIT = "showSiteCredit"

const initialState = {
  mousePosition: { x: null, y: null },
  touchPosition: { x: null, offsetX: null, y: null, offsetY: null },
  windowSize: { x: 0, y: 0 },
  mouseDiff: { x: 0, y: 0 },
  containerSize: { x: 0, y: 0 },
  modal: false,
  capabilitiesIndex: 0,
  mobile: false,
  energyModal: false,
  initialPageLoad: true,
  showInfoPopup: false,
  infoPopupData: {
    type: null,
    title: null,
    info: null,
    link: null,
  },
  showAnnouncementBar: false,
  announcementBarData: {
    type: null,
    title: null,
    info: null,
  },
  mainDrawer: null,
  showSiteCredit: false,
}

export const setMousePosition = obj => {
  return {
    type: MOUSE_POSITION,
    obj,
  }
}

export const setTouchPosition = obj => {
  return {
    type: TOUCH_POSITION,
    obj,
  }
}

export const setWindowSize = obj => {
  return {
    type: WINDOW_SIZE,
    obj,
  }
}

export const setContainerSize = obj => {
  return {
    type: CONTAINER_SIZE,
    obj,
  }
}

export const setMouseDiff = obj => {
  return {
    type: MOUSE_DIFF,
    obj,
  }
}

export const setModal = bool => {
  return {
    type: MODAL,
    bool,
  }
}

export const setCapabilitiesIndex = int => {
  return {
    type: CAPABILITIES_INDEX,
    int,
  }
}

export const setMobile = bool => {
  return {
    type: MOBILE,
    bool,
  }
}

export const setEnergyModal = bool => {
  return {
    type: ENERGY_MODAL,
    bool,
  }
}

export const setInitialPageLoad = bool => {
  return {
    type: INITIAL_PAGE_LOAD,
    bool,
  }
}

export const setShowInfoPopup = bool => {
  return {
    type: SHOW_INFO_POPUP,
    bool,
  }
}

export const setInfoPopupData = obj => {
  return {
    type: INFO_POPUP_DATA,
    obj,
  }
}

export const setShowAnnoucementBar = bool => {
  return {
    type: SHOW_ANNOUNCEMENT_BAR,
    bool,
  }
}

export const setAnnouncementBarData = obj => {
  return {
    type: ANNOUNCEMENT_BAR_DATA,
    obj,
  }
}

export const setMainDrawer = int => {
  return {
    type: MAIN_DRAWER,
    int,
  }
}
export const setShowSiteCredit = bool => {
  return {
    type: SHOW_SITE_CREDIT,
    bool,
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case MOUSE_POSITION:
      return Object.assign({}, state, {
        mousePosition: action.obj,
      })
    case TOUCH_POSITION:
      return Object.assign({}, state, {
        touchPosition: action.obj,
      })
    case WINDOW_SIZE:
      return Object.assign({}, state, {
        windowSize: action.obj,
      })
    case CONTAINER_SIZE:
      return Object.assign({}, state, {
        containerSize: action.obj,
      })
    case MOUSE_DIFF:
      return Object.assign({}, state, {
        mouseDiff: action.obj,
      })
    case MODAL:
      return Object.assign({}, state, {
        modal: action.bool,
      })
    case CAPABILITIES_INDEX:
      return Object.assign({}, state, {
        capabilitiesIndex: action.int,
      })
    case MOBILE:
      return Object.assign({}, state, {
        mobile: action.bool,
      })
    case ENERGY_MODAL:
      return Object.assign({}, state, {
        energyModal: action.bool,
      })
    case INITIAL_PAGE_LOAD:
      return Object.assign({}, state, {
        initialPageLoad: action.bool,
      })
    case SHOW_INFO_POPUP:
      return Object.assign({}, state, {
        showInfoPopup: action.bool,
      })
    case INFO_POPUP_DATA:
      return Object.assign({}, state, {
        infoPopupData: action.obj,
      })
    case SHOW_ANNOUNCEMENT_BAR:
      return Object.assign({}, state, {
        showAnnouncementBar: action.bool,
      })
    case ANNOUNCEMENT_BAR_DATA:
      return Object.assign({}, state, {
        announcementBarData: action.obj,
      })
    case MAIN_DRAWER:
      return Object.assign({}, state, {
        mainDrawer: action.int,
      })
    case SHOW_SITE_CREDIT:
      return Object.assign({}, state, {
        showSiteCredit: action.bool,
      })
    default:
      return state
  }
}
